var render = function render(_c,_vm){return _c('transition',{attrs:{"appear":_vm.props.appear,"css":false},on:{"enter":_vm.$options.methods.enter,"leave":_vm.$options.methods.leave}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }